import { ResourceDetailEditButton } from 'app/components/Resources/ResourceDetail/ResourceDetailEdit/styled';
import styled from 'styled-components';
import { BREAKPOINTS } from 'styles/media';

export const ResourceSubmissionPreviewWrapper = styled.div`
  min-height: 100%;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 35px;

  ${ResourceDetailEditButton} {
    display: none;
  }

  padding-bottom: 160px;

  ${BREAKPOINTS.tablet} {
    padding-bottom: 0px;
  }
`;

export const ResourceSubmissionPreviewGoBackButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
`;

export const ResourceSubmissionPreviewGoBackButtonText = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: normal;
  letter-spacing: 1.4px;
  text-transform: uppercase;

  color: #000;
`;

export const ResourceSubmissionPreviewTitleWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  ${BREAKPOINTS.tablet} {
    flex-direction: column-reverse;
    align-items: center;
    justify-content: center;
    gap: 12px;
  }
`;

export const ResourceSubmissionPreviewTitle = styled.h3`
  font-weight: 400;
  font-size: 38px;
  line-height: normal;

  color: var(--color-text);

  ${BREAKPOINTS.tablet} {
    font-size: 24px;
  }
`;

export const ResourceSubmissionPreviewCategory = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  max-width: 100%;
  color: var(--color-text);
  font-size: 18px;
  line-height: 1.4;
  overflow-wrap: anywhere;

  > :first-child {
    width: 32px;
    height: 32px;
    flex-shrink: 0;
  }
`;
